"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canMirrorQuery = canMirrorQuery;
exports.getMirroredItemName = getMirroredItemName;
exports.getMirroredQuery = getMirroredQuery;
exports.inferMirroredName = inferMirroredName;
var _measurements = require("./measurements");
var _filters = require("../util/filters");
var _query = require("./query");
function inferMirroredName(name) {
  if (name.includes('src') || name.includes('dst')) {
    return name.replace(/src|dst/, match => match === 'src' ? 'dst' : 'src');
  }
  if (name.includes('input') || name.includes('output')) {
    return name.replace(/input|output/, match => match === 'input' ? 'output' : 'input');
  }
  if (name.includes('in_') || name.includes('out_')) {
    return name.replace(/in_|out_/, match => match === 'in_' ? 'out_' : 'in_');
  }
  if (name.includes('in-') || name.includes('out-')) {
    return name.replace(/in-|out-/, match => match === 'in-' ? 'out-' : 'in-');
  }
  return null;
}
function getMirroredItemName(measurement, type, name) {
  const item = (0, _measurements.getMeasurementItem)(measurement, type, name);
  const mirroredName = item?.Inverse || inferMirroredName(name);
  if (mirroredName && (0, _measurements.getMeasurementItem)(measurement, type, mirroredName)) {
    return mirroredName;
  }
  return null;
}
function getMirroredQuery(query, measurement) {
  const mirroredQuery = structuredClone(query);
  mirroredQuery.metrics = mirroredQuery.metrics.map(metric => {
    const mirroredName = getMirroredItemName(measurement, 'metric', metric.name);
    return mirroredName ? {
      ...metric,
      name: mirroredName
    } : metric;
  });
  mirroredQuery.dimensions = mirroredQuery.dimensions.map(dimension => {
    const mirroredName = getMirroredItemName(measurement, 'dimension', dimension.name);
    return mirroredName ? {
      ...dimension,
      name: mirroredName
    } : dimension;
  });
  mirroredQuery.window = mirroredQuery.window ? {
    ...mirroredQuery.window,
    fn: mirroredQuery.window.fn ? Object.fromEntries(Object.entries(mirroredQuery.window.fn).map(([key, value]) => {
      const mirroredName = getMirroredItemName(measurement, 'metric', key);
      return mirroredName ? [mirroredName, value] : [key, value];
    })) : undefined
  } : undefined;
  mirroredQuery.rollups = mirroredQuery.rollups.map(rollup => {
    const mirroredName = getMirroredItemName(measurement, 'metric', rollup.metric);
    return mirroredName ? {
      ...rollup,
      metric: mirroredName
    } : rollup;
  });
  mirroredQuery.sort = mirroredQuery.sort?.map(sort => {
    // find rollup in original query
    const rollup = query.rollups.find(r => (0, _query.getRollupKey)(r) === sort.rollup);
    if (rollup) {
      const mirroredName = getMirroredItemName(measurement, 'metric', rollup.metric);
      if (mirroredName) {
        return {
          ...sort,
          rollup: (0, _query.getRollupKey)({
            ...rollup,
            metric: mirroredName
          })
        };
      }
    }
    return sort;
  });
  if (mirroredQuery.filters.dimensions) {
    mirroredQuery.filters.dimensions = (0, _filters.mapFilters)(mirroredQuery.filters.dimensions, filter => {
      const mirroredField = getMirroredItemName(measurement, 'dimension', filter.filterField);
      if (mirroredField) {
        return {
          ...filter,
          filterField: mirroredField
        };
      }
      return filter;
    });
  }
  if (mirroredQuery.filters.metrics) {
    mirroredQuery.filters.metrics = (0, _filters.mapFilters)(mirroredQuery.filters.metrics, filter => {
      if (filter.metric) {
        const mirroredName = getMirroredItemName(measurement, 'metric', filter.metric);
        if (mirroredName) {
          return {
            ...filter,
            filterField: filter.filterField.replace(filter.metric, mirroredName),
            metric: mirroredName
          };
        }
      }
      return filter;
    });
  }
  return mirroredQuery;
}
function canMirrorQuery(query, measurement) {
  return query.metrics.some(metric => getMirroredItemName(measurement, 'metric', metric.name) !== null) || query.dimensions.some(dimension => getMirroredItemName(measurement, 'dimension', dimension.name) !== null) || (0, _filters.someFilters)(query.filters.dimensions, filter => getMirroredItemName(measurement, 'dimension', filter.filterField) !== null) || (0, _filters.someFilters)(query.filters.metrics, filter => !!filter.metric && getMirroredItemName(measurement, 'metric', filter.metric) !== null);
}